// action types
export const SET_SURGERY_MODE = "SET_SURGERY_MODE";

// action creators
export const setSurgeryMode = function (isOn) {
    return {
        type: SET_SURGERY_MODE,
        isOn: isOn,
    };
};
